<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.form.get('id').value">Ajouter un article</h3>
      <h3 *ngIf="this.form.get('id').value">Modifier un article</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">
        <div class="col-sm-3">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" name="code" formControlName="code" maxlength="15" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
                <mat-error *ngIf="form.get('code').hasError('max')">
                    Le code est trop long
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" maxlength="40" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            <mat-error *ngIf="form.get('libelle').hasError('max')">
                Le libelle est trop long
            </mat-error>
            </mat-form-field>
        </div>
       

        <div class="col-sm-4">
            <app-autocomplete-with-code-libelle-form   
              name="Categorie" [parent]="form"  
              libelle="Catégorie" 
              codeControlName="codeCategorie"
              libelleControlName="libelleCategorie"
              [objets]="data.referentiel.categories"
              [required]="false">
          </app-autocomplete-with-code-libelle-form>
        </div>

        <div class="col-sm-3">
          <mat-form-field class="full-width">
          <mat-label>Prix unitaire</mat-label>
          <input matInput name="pu" formControlName="pu" type="number" required>
          <mat-error *ngIf="form.get('pu').hasError('required')">
              Veuillez saisir un prix unitaire
          </mat-error>
          <mat-error *ngIf="form.get('pu').hasError('min')">
              Le prix doit etre positif
          </mat-error>
          </mat-form-field>
        </div>

        <div class="col-sm-4">
          <app-autocomplete-with-code-form   
          name="codeSite" [parent]="form"  
          libelle="Site" 
          [objets]="sites" 
          [(objet)]="site">
          </app-autocomplete-with-code-form>
        </div>


        <div class="col-sm-4">
            <app-autocomplete-with-code-libelle-form   
              name="codeTva" [parent]="form"  
              libelle="TVA" 
              [objets]="this.data.referentiel.tvas" 
              codeControlName="codeTva"
              libelleControlName="libelleTva">
            </app-autocomplete-with-code-libelle-form>
        </div>

        <div class="col-sm-3">
          <mat-form-field appearance="outline" style="float: center;">
            <mat-label>Commun</mat-label>
            <mat-select formControlName="commun">
              <mat-option [value]="true" >Oui</mat-option>
              <mat-option [value]="false" >Non</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-sm-4">
            <app-autocomplete-with-code [(objet)]="this.famille" name="ssFamille" (objetChange)="onChangeFamille($event)"
                  libelle="Famille" [objets]="this.familles">
            </app-autocomplete-with-code>
        </div>

        <div class="col-sm-4">
            <app-autocomplete-with-code [(objet)]="this.domaine" name="ssDomaine" (objetChange)="onChangeDomaine($event)"
                  libelle="Domaine" [objets]="this.domaines">
            </app-autocomplete-with-code>
        </div>

        <div class="col-sm-6">
          <app-autocomplete-with-code-libelle-form   
            name="codeNa" [parent]="form"  
            libelle="Nature analytique" 
            [objets]="this.data.referentiel.nas"
            codeControlName="codeNa"
            libelleControlName="libelleNa">
          </app-autocomplete-with-code-libelle-form>
        </div>

        <div class="col-sm-6">
            <app-autocomplete-with-code-libelle-form   
              name="codeCg" [parent]="form"  
              libelle="CG Charge" 
              [objets]=[] 
              codeControlName="codeCg"
              libelleControlName="libelleCg">
            </app-autocomplete-with-code-libelle-form>
        </div>
       
    </form>   
</div>
  
<div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
</div>

